module.exports = __webpack_public_path__ + "img/a8cb1b9.jpg";